import React, {useRef, useState, useEffect} from "react";
import styles from "./InfoItem.module.css";
import classNames from "classnames"
import {useDispatch, useSelector} from "react-redux";
import {Button, Checkbox, Col, message, Row, Switch} from 'antd'

export default function InfoItem(props) {
    const dispatch = useDispatch();
    const [confirmInfo, setConfirmInfo] = useState({})
    const [messageApi, contextHolder] = message.useMessage();


    return <tr
        className={styles.tr1}
    >
        <td
            className={styles.td1}
        >{props.item.shengfen_name}
        </td>
        <td
            className={styles.td1}
        >{props.item.school_name}
        </td>
        <td
            className={styles.td1}
        >{props.item.name}
        </td>

        <td
            className={styles.td1}
        >
            <Switch
                checked={props.item.status == 1}
                onChange={(checked) => {
                    console.log(checked);
                    props.changeStatus(props.item, checked);
                }}
                checkedChildren="开"
                unCheckedChildren="关"
                // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
                style={{marginLeft: 10, marginRight: 10}}
            />

        </td>
        <td
            className={styles.td1}
        >{props.item.ctime}
        </td>
        <td
            className={styles.td2}
        >
            <div style={{ display: "flex", justifyContent: "center",width: "100%" }}>
                <Row style={{width: "100px"}}>
                    <Col span={12}>
                        <Button
                            color="primary"
                            variant="link"
                            onClick={() => {
                                props.editMethod(props.item);
                            }}
                        >
                            编辑
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button
                            color="primary"
                            variant="link"
                            onClick={(e) => {
                                props.deleteMethod(props.item);
                            }}
                        >
                            删除
                        </Button>
                    </Col>
                </Row>
            </div>
        </td>

        {contextHolder}
    </tr>
}
// export default PaymentInfoList;

